"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RadioContainer = _interopRequireDefault(require("./RadioContainer"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var getFlexDirection = function getFlexDirection(isHorizontal) {
  return isHorizontal ? 'row' : 'column';
};
var getMargin = function getMargin(isHorizontal, theme) {
  return isHorizontal ? "margin-left: ".concat(theme.horizontalGroupMargin) : "margin-top: ".concat(theme.verticalGroupMargin);
};
var RadioGroupWrapper = _styledComponents["default"].fieldset(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: ", ";\n  ", " ~ ", " {\n    ", "\n  }\n  align-items: start;\n"])), function (_ref) {
  var isHorizontal = _ref.isHorizontal;
  return getFlexDirection(isHorizontal);
}, _RadioContainer["default"], _RadioContainer["default"], function (props) {
  return getMargin(props.isHorizontal, props.theme);
});
var _default = RadioGroupWrapper;
exports["default"] = _default;